import * as React from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import { LoadingSpinner } from '@sales-center/components'

type DeleteDialogProps = {
  open: boolean
  loading: boolean
  usageCount?: number
  onClose: () => void
  onDelete: () => void
  onTransitionEnd: () => void
}

export function DeleteDialog(props: DeleteDialogProps) {
  const {
    open,
    loading,
    usageCount = -1,
    onClose,
    onDelete,
    onTransitionEnd,
  } = props

  const text =
    usageCount > 0
      ? `This field is in use by ${usageCount} ${
          usageCount === 1 ? 'record' : 'records'
        }.`
      : 'This field is not in use.'

  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth="xs"
      onClose={onClose}
      onTransitionEnd={onTransitionEnd}
    >
      <DialogTitle>Delete Custom Field</DialogTitle>

      <DialogContent>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <DialogContentText>
            {text} Are you sure you want to delete it?
          </DialogContentText>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onDelete} disabled={loading}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
